<template>
  <div class="w-full flex flex-row algolia-search-bar-input__size-lg bg-white rounded-full p-2 h-[70px]">
    <fa
      icon="location-dot"
      size="xl"
      class="text-secondary mr-3 my-auto ml-4"
    />

    <input
      ref="input"
      type="search"
      autocomplete="off"
      class="placeholder:!text-black placeholder:font-bold"
      :placeholder="placeholderText"
      :value="value"
      @keydown="$emit('activate', $event)"
      @keyup.enter="$emit('goto', value)"
      @input="$emit('refine', $event.currentTarget.value)"
    />

    <button
      class="font-semibold text-center min-h-full ml-auto rounded-full flex items-center !text-lg px-10 whitespace-nowrap"
      :class="$isSol ? 'btn-orange uppercase' : 'btn-secondary'"
      type="button"
    >
      <SearchIconSVG class="mr-2" />
      {{ $t('searchNow') }}
    </button>
  </div>
</template>

<script setup>
import SearchIconSVG from '@packages/icons/search-icon.svg'

defineProps({
  value: {
    type: String,
    default: '',
  },
})

defineEmits([
  'refine',
  'goto',
  'activate',
])

const { t } = useI18n()

const isHydrated = ref(false)

const { isWider } = useScreen()

const placeholderText = computed(() => {
  if (!isHydrated.value) {
    return ''
  }

  if (isWider('sm')) {
    return t('searchFieldPlaceholder')
  }

  return t('searchFieldPlaceholderMobile')
})

const inputRef = useTemplateRef('input')

defineExpose({ inputRef })

onMounted(() => {
  isHydrated.value = true
})
</script>

<style lang="scss">
.algolia-search-bar-input {
  &__size-lg {
    .algolia-search-bar-btn-wrapper {
      padding: 12px 12px 12px 0;

      .identity--rolfs & {
        padding: 12px 5px 12px 0;
      }
    }
  }
}
</style>